import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { defaultPaging } from '@/common/constants/ConstCode';

const state = {
  // ---- ---- 페이징 정보 저장 ---- ----
  userItemCondition: {
    ...defaultPaging,
    userNo: '',
    category: ''
  },
  userPageInfo: { totalPage: 2, page: 1, limit: 10, startPage: 1, endPage: 1 },
  detail: {},
  list: [],
  shopItemList: [],
  buyMemorialItemList: [],
  userItemList: [],
  categoryShopList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
